module.exports = __webpack_public_path__ + "img/de_Ecran 4.209d131d.png";